import React from "react";
import { Container } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import "./AgriStackComponent.css";
import "react-awesome-slider/dist/styles.css";
import ecoSystemViewImg from "../../images/product.png";
import AgriTechStack from "../../images/agriculture.png";
import { NavLink } from "react-router-dom";
import { Typography } from "@material-ui/core";

// Stack data containing information about different technology stacks
const stackData = [
  {
    title: "MultiCloud Stack", 
    image: ecoSystemViewImg, 
    path: "/multi-cloud-stack", 
  },
  {
    title: "AgriChain - OminiCore Stack", 
    image: AgriTechStack, 
    path: "/agri-cloud-stack", 
  },
  {
    title: "AgriCommerce Stack", 
    image: AgriTechStack, 
    path: "/agri-commerce-stack", 
  },
];

// Main component rendering the AgriCloud stack 
const AgriCloudStacknew = () => {
  return (
    <div
      maxwidth={12} // Defines the maximum width of the container
      className="businessPartnerContainer explore-app-background"
    >
      {/* Container for grid layout */}
      <Container maxWidth="sm" className="gridSection gridSection--mod">
        <Grid
          container={true} 
          alignItems="center" 
          spacing={1} 
          direction="row" 
          justifyContent="center" 
        >
          {/* Mapping through stackData to render each stack */}
          {stackData.map(({ title, image, path }, index) => {
            return (
              <Grid
                item 
                md={2}
                sm={4} 
                xs={6} 
                key={index} 
                className="stack-data-container"
              >
                {/* Navigation link to stack details */}
                <NavLink to={path}>
                  <img src={image} alt={title} /> {/* Displays stack image */}
                  <Typography variant="h4" align="center">
                    {title} {/* Displays stack title */}
                  </Typography>
                </NavLink>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </div>
  );
};

export default AgriCloudStacknew; // Exporting the component for use

